const RankIcon = ({ rank = 1 }: { rank?: number }) => (
  <svg width="38" height="40" viewBox="0 0 38 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.7063 7.81417L25.2122 1.5397C25.3358 1.23024 25.6573 1.02441 26.0172 1.02441H37.1428C37.6162 1.02441 37.9999 1.3758 37.9999 1.80926V4.70755C37.9999 4.87142 37.9439 5.03118 37.8398 5.16442L32.823 11.5809C32.5507 11.9292 32.0233 12.0111 31.6298 11.7796C28.0729 9.68679 25.0885 9.10614 23.3583 8.83906C22.8348 8.75824 22.524 8.27075 22.7063 7.81417Z"
      fill="currentColor"
    />
    <path
      d="M0.853495 0.344727H12.6301C13.1009 0.344727 13.6735 0.628687 13.8685 1.04206C14.5025 2.38585 15.7891 5.35944 16.7428 7.59265C16.9736 8.13315 16.5603 8.72888 15.9564 8.77795C12.1307 9.08888 8.12976 10.6968 5.92088 11.8118C5.47163 12.0385 4.90972 11.8641 4.70162 11.4181L0.0760848 1.50457C-0.177826 0.960391 0.234835 0.344727 0.853495 0.344727Z"
      fill="currentColor"
    />
    <path
      d="M32.7587 25.2409C32.7587 33.2014 26.3054 39.6547 18.3449 39.6547C10.3844 39.6547 3.93115 33.2014 3.93115 25.2409C3.93115 17.2804 10.3844 10.8271 18.3449 10.8271C26.3054 10.8271 32.7587 17.2804 32.7587 25.2409Z"
      fill="currentColor"
    />
    <text x={12} y={31} className="fill-white text-[16px] font-[700]">
      {rank}
    </text>
  </svg>
);

export default RankIcon;
